import { Sidebar as SemanticSidebar } from 'semantic-ui-react';
import styled from 'styled-components';

const Sidebar = styled(SemanticSidebar)`
  &.ui.sidebar {
    align-items: center;
    background-color: ${(props) => props.theme.color.sidebar};
    border-right: solid 1px ${(props) => props.theme.color.sidebarBorder};
    height: 100%;
    letter-spacing: 0.65px;
    z-index: 1;
  }

  &.ui.left.visible.sidebar {
    box-shadow: none;
    z-index: 101;
  }
`;

export default Sidebar;
